exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-contact-me {\n  display: block;\n}\nfi-contact-me .a-link {\n  color: #000;\n  text-decoration: none;\n  font-weight: 600;\n}\nfi-contact-me .a-link:hover {\n  text-decoration: underline;\n}", ""]);

// exports
